document.addEventListener("DOMContentLoaded", function () {
  const dropdownWrapper = document.querySelector(".dropdown-wrapper4");
  dropdownWrapper.classList.add("closed");

  const dropdownHeader = document.querySelector(".dropdown-header4");
  const dropdownMenu = document.querySelector(".dropdown-menu4");
  const dropdownItems = document.querySelectorAll(".meta-dropdown-items");
  const selectedPrinter = document.querySelector(".selected-printer4");
  const printerListContainer = document.getElementById(
    "printer-list-container"
  );
  const searchButtons = document.querySelectorAll(".search-button4");
  const mobileSearchButton = document.querySelector(
    ".search-button4.mobile-only"
  );
  const searchInput = document.querySelector(".search-input4");
  const dropdownMenu5 = document.querySelector(".dropdown-menu5");

  let selectedName = "";

  // Disable mobile button by default
  if (mobileSearchButton) {
    mobileSearchButton.disabled = true;
  }

  let counter = 0;
  if (counter++ === 0) {
    const url = new URL(window.location);
    const searchValue = url.searchParams.get("search");
    if (searchValue) {

      const filteredPrinters = printers.filter((printer) =>
        printer.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      const filteredPrintersSelect = printers.filter(
        (printer) => printer.name.toLowerCase() == searchValue.toLowerCase()
      );

      if (filteredPrinters && filteredPrinters.length > 0) {
        displayFilteredPrinters(filteredPrinters);
        if (filteredPrintersSelect && filteredPrintersSelect.length > 0) {
          document.getElementsByClassName("selected-printer4")[0].innerHTML =
            searchValue || "Select a printer";
          document
            .querySelector(".dropdown-header4")
            .classList.add("printer-selected");
        } else {
          document.getElementsByClassName("search-input4")[0].value =
            searchValue || "or Search for a printer";
        }
      }
    }
  }

  dropdownHeader.addEventListener("click", function () {
    const isOpen = dropdownWrapper.classList.toggle("open");
    dropdownWrapper.classList.toggle("closed", !isOpen);
    searchInput.value = "";
    searchInput.dispatchEvent(new Event("input", { bubbles: true }));
  });

  dropdownItems.forEach((item) => {
    item.addEventListener("click", function () {
      selectedName = this.getAttribute("data-name");
      selectedPrinter.textContent = selectedName;
      dropdownHeader.classList.add("printer-selected");
      dropdownWrapper.classList.remove("open");
      dropdownWrapper.classList.add("closed");

      // Enable mobile button when printer is selected
      if (mobileSearchButton) {
        mobileSearchButton.disabled = false;
      }
    });
  });

  searchButtons.forEach((button) => {
    button.addEventListener("click", function () {

      const keyword = selectedName || searchInput.value.trim();

      // Update the URL parameter without reloading the page
      const url = new URL(window.location);
      url.searchParams.set("search", keyword);
      window.history.replaceState({}, "", url);

      const filteredPrinters = printers.filter((printer) =>
        printer.name.toLowerCase().includes(keyword.toLowerCase())
      );

      displayFilteredPrinters(filteredPrinters);
    });
  });

  searchInput.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      const keyword = searchInput.value.trim();

      const filteredPrinters = printers.filter((printer) =>
        printer.name.toLowerCase().includes(keyword.toLowerCase())
      );

      displayFilteredPrinters(filteredPrinters);

      const singleImageVideoSection = document.querySelector(
        ".icc-color-single-image-video-container"
      );
      if (singleImageVideoSection) {
        singleImageVideoSection.style.display = "none";
      }
    }
  });

  searchInput.addEventListener("input", function () {
    const filterKeyword = searchInput.value.trim().toLowerCase();

    if (filterKeyword === "") {
      dropdownMenu5.style.display = "none";
      return;
    }

    dropdownMenu5.style.display = "block";

    const dropdownItems = dropdownMenu5.querySelectorAll(
      ".meta-dropdown-items-search"
    );
    let hasMatches = false;

    dropdownItems.forEach((item) => {
      const printerName = item.getAttribute("data-name").toLowerCase();
      const isMatch = printerName.includes(filterKeyword);
      item.style.display = isMatch ? "block" : "none";
      if (isMatch) hasMatches = true;
    });

    const noMessage = dropdownMenu5.querySelector(".no-printers-message");
    if (!hasMatches) {
      if (!noMessage) {
        const noPrintersMessage = document.createElement("li");
        noPrintersMessage.classList.add("no-printers-message");
        noPrintersMessage.textContent = "No printers found";
        dropdownMenu5.appendChild(noPrintersMessage);
      }
    } else {
      if (noMessage) noMessage.remove();
    }
  });

  dropdownMenu5.addEventListener("click", function (event) {
    const item = event.target.closest(
      ".meta-dropdown-items, .meta-dropdown-items-search"
    );
    if (item) {
      selectedName = item.getAttribute("data-name");
      searchInput.value = selectedName;
      dropdownMenu5.style.display = "none";
      selectedPrinter.textContent = selectedName;
      dropdownHeader.classList.add("printer-selected");

      // Enable mobile button when printer is selected via search
      if (mobileSearchButton) {
        mobileSearchButton.disabled = false;
      }
    }
  });

  document.addEventListener("click", function (event) {
    if (
      !dropdownWrapper.contains(event.target) &&
      !searchInput.contains(event.target) &&
      !dropdownMenu5.contains(event.target)
    ) {
      dropdownWrapper.classList.remove("open");
      dropdownWrapper.classList.add("closed");
      dropdownMenu5.style.display = "none";
    }
  });

  function displayFilteredPrinters(filteredPrinters) {
    const singleImageVideoSection = document.querySelector(
      ".icc-color-single-image-video-container"
    );
    if (singleImageVideoSection) {
      singleImageVideoSection.style.display = "none";
    }
    printerListContainer.style.display = "block";

    const printerCountMessage = document.getElementById(
      "printer-count-message"
    );
    const printerListDescription = document.getElementById(
      "printer-list-description"
    );

    printerCountMessage.style.display = "block";
    printerListDescription.style.display = "block";

    const oldList = document.querySelector(".printer-list");
    if (oldList) oldList.remove();

    if (filteredPrinters.length > 0) {
      printerCountMessage.textContent = `Found ${
        filteredPrinters.length
      } matching printer profile${filteredPrinters.length > 1 ? "s" : ""}`;
      printerListDescription.innerHTML =
        printerListDescription.getAttribute("data-default");

      const ulElement = document.createElement("ul");
      ulElement.classList.add("printer-list");

      filteredPrinters.forEach((printer) => {
        const liElement = document.createElement("li");
        const printerId = encodeURIComponent(printer.id);
        liElement.classList.add("printer-item");
        liElement.innerHTML = `
          <a href="/pages/icc-colour-profile-result?id=${printerId}" class="printer-link">
            ${
              printer.image
                ? `<img src="${printer.image}" alt="${printer.name}">`
                : ""
            }
            <div class="rip-ink-content-wrapper">
              <p class="printer-result-name">${printer.name}</p>
               ${
                 printer.rip
                   ? `<p class="printer-rip-ink-result-name"><span>RIP:</span> ${printer.rip}</p>`
                   : ""
               }
              ${
                printer.ink
                  ? `<p class="printer-rip-ink-result-name"><span>Ink Set:</span> ${printer.ink}</p>`
                  : ""
              }
            </div>
          </a>
        `;

        liElement
          .querySelector(".printer-link")
          .addEventListener("click", function (event) {
            event.preventDefault();
            const printerName = encodeURIComponent(printer.name); // Encode the printer name
            const printerNameAndRip = encodeURIComponent(
              `${printer.name} - ${printer.rip}`
            );
            window.location.href = `/pages/icc-colour-profile-result?id=${printerId}&name=${printerNameAndRip}`;
          });

        ulElement.appendChild(liElement);
      });

      printerListContainer.appendChild(ulElement);
    } else {
      printerCountMessage.textContent = "No matching printer profiles found.";
      printerListDescription.textContent = "";
    }
  }
});
